// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__dP35A","large":"styles_large__2r0Eb"};